var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { dense: "" } },
    _vm._l(
      _vm.stats.filter((e) => !e.hide),
      function (stat, i) {
        return _c(
          "v-col",
          { key: stat.title, attrs: { cols: "6", sm: "3", md: "2", lg: "2" } },
          [
            _c(
              "v-card",
              { staticClass: "soli-round" },
              [
                _c(
                  "v-container",
                  [
                    _c(
                      "div",
                      { staticClass: "flex justify-center align-center pb-1" },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              round: "",
                              outlined: "",
                              color: stat.color,
                            },
                          },
                          [_vm._v(_vm._s(stat.icon))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    stat.data || stat.data === 0
                      ? _c(
                          "v-card-title",
                          {
                            staticClass: "soli-grey justify-center py-1",
                            staticStyle: { "white-space": "nowrap" },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(stat.data) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !stat.data && stat.data !== 0
                      ? _c("v-skeleton-loader", {
                          staticClass: "mx-auto py-0 stats-skeleton",
                          attrs: {
                            height: "40",
                            "max-width": "120",
                            type: "list-item",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex justify-center soli-grey text-sm" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(stat.title) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }
    ),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }